import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "filter filter-date" }
const _hoisted_2 = { class: "d-flex ga-4" }
const _hoisted_3 = { class: "filter filter-madeBy" }
const _hoisted_4 = { class: "filter filter-event-type" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "filter filter-status" }
const _hoisted_7 = { class: "filter filter-event-id" }
const _hoisted_8 = { class: "align-content-end" }

import { reactive } from "vue";
import { formatDateTime } from "@/filters";
import DatePicker from 'vue-datepicker-next';
import Input from "@intec/vue-components/form/Input.vue";
import ExtendedSearch from "@intec/vue-components/search/ExtendedSearch.vue";
import Config from '@/config';


export default /*@__PURE__*/_defineComponent({
  __name: 'LogEventsFilter',
  props: {
  tableModel: {
    type: Object,
    required: true
  },
  eventList: {
    type: Object,
    required: true
  },
},
  setup(__props) {

const props = __props;
const lang = Config.getUser().getLang();

const searchParams = reactive({
  createdAt: {
    dates: [],
  },
  madeByUsername: null,
  selectedEventIds: [],
  isSuccess: null,
  id: null,
});

const onUpdateSelectedEventIds = (newValue) => {
  if (Array.isArray(newValue)) {
    searchParams.selectedEventIds = newValue.filter(id => {
      return props.eventList.some(event => event.id === id);
    });
  }
};

const searchFn = () => {
  const apiParams = {};

  if (searchParams.createdAt.dates[0]) {
    apiParams['createdAt[after]'] = formatDateTime(searchParams.createdAt.dates[0]);
  }
  
  if (searchParams.createdAt.dates[1]) {
    const beforeDate = new Date(searchParams.createdAt.dates[1]);
    beforeDate.setHours(23, 59, 59, 999);
    apiParams['createdAt[before]'] = formatDateTime(beforeDate.toISOString());
  }

  if (searchParams.madeByUsername) {
    apiParams['madeBy.username'] = searchParams.madeByUsername;
  }

  if (searchParams.selectedEventIds) {
    apiParams['event.id'] = searchParams.selectedEventIds;
  }

  if (searchParams.isSuccess !== null) {
    apiParams['success'] = searchParams.isSuccess;
  }

  if (searchParams.id) {
    apiParams['id'] = searchParams.id;
  }

  props.tableModel.bind.options.page = 1;
  props.tableModel.reload({ searchParams: apiParams });
};

const resetFormFn = () => {
  searchParams.createdAt.dates = [];
  searchParams.madeByUsername = null;
  searchParams.selectedEventIds = [];
  searchParams.isSuccess = null;
  searchParams.id = null;
  props.tableModel.bind.options.page = 1;
  props.tableModel.reload({ searchParams: searchParams });
};

return (_ctx: any,_cache: any) => {
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$t('Дата')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(DatePicker), {
          placeholder: _ctx.$t('С'),
          value: searchParams.createdAt.dates[0],
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.createdAt.dates[0]) = $event)),
          lang: _unref(lang)
        }, null, 8 /* PROPS */, ["placeholder", "value", "lang"]),
        _createVNode(_unref(DatePicker), {
          placeholder: _ctx.$t('По'),
          value: searchParams.createdAt.dates[1],
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.createdAt.dates[1]) = $event)),
          lang: _unref(lang)
        }, null, 8 /* PROPS */, ["placeholder", "value", "lang"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.$t('Пользователь-субъект')), 1 /* TEXT */),
      _createVNode(Input, {
        placeholder: "Поиск по логину пользователя",
        modelValue: searchParams.madeByUsername,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.madeByUsername) = $event)),
        "hide-details": "",
        "clear-icon": "mdi-close",
        clearable: ""
      }, null, 8 /* PROPS */, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.$t('Действие')), 1 /* TEXT */),
      _createVNode(_component_v_combobox, {
        placeholder: _ctx.$t('Тип запроса'),
        modelValue: searchParams.selectedEventIds,
        "onUpdate:modelValue": [
          _cache[3] || (_cache[3] = ($event: any) => ((searchParams.selectedEventIds) = $event)),
          onUpdateSelectedEventIds
        ],
        disabled: !props.eventList.length,
        items: props.eventList,
        "return-object": false,
        "item-title": "name",
        "item-value": "id",
        multiple: "",
        variant: "solo",
        "hide-details": "",
        "clear-icon": "mdi-close",
        clearable: ""
      }, {
        selection: _withCtx(({ index }) => [
          (index === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('Выбрано:')) + " " + _toDisplayString(searchParams.selectedEventIds.length), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["placeholder", "modelValue", "disabled", "items"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.$t('Статус')), 1 /* TEXT */),
      _createVNode(_component_v_select, {
        placeholder: _ctx.$t('Результат'),
        modelValue: searchParams.isSuccess,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchParams.isSuccess) = $event)),
        items: [
        { title: _ctx.$t('Успешно'), value: true },
        { title: _ctx.$t('Неудачно'), value: false },
      ],
        variant: "solo",
        "hide-details": "",
        "clear-icon": "mdi-close",
        clearable: ""
      }, null, 8 /* PROPS */, ["placeholder", "modelValue", "items"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createTextVNode(_toDisplayString(_ctx.$t('ID события')), 1 /* TEXT */),
      _createVNode(Input, {
        placeholder: "ID",
        modelValue: searchParams.id,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchParams.id) = $event)),
        type: "number",
        "hide-details": "",
        "clear-icon": "mdi-close",
        clearable: ""
      }, null, 8 /* PROPS */, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(ExtendedSearch, {
        "table-model": __props.tableModel,
        "search-params": searchParams,
        onSearch: searchFn,
        onResetSearch: resetFormFn
      }, null, 8 /* PROPS */, ["table-model", "search-params"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})